import { Card, Tabs } from "@shopify/polaris"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "../../../actions"
import UnsentNotifications from "../../../pages/UnsentNotifications"
import SentNotifications from "../../../pages/SentNotifications"
import AllNotifications from "../../../pages/AllNotifications"
// import NotificationsSetting from "../../../pages/NotificationsSetting"
import axios from "../../../funcs/axios"
function mapStateToProps(state) {
    return {
        store: state,
        pre_order_pages: state.pre_order_pages,
        widgets: state.widgets,
        plan: state.plan,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}

const INITIAL_STATE = {
    selected: 0,
    unsent_notifications: [],
    sent_notifications: [],
    all_notifications: [],
    loading: true,
    count_mail: 0,
}

class AppBodyNotifications extends Component {
    constructor(props) {
        super(props)
        this.state = Object.assign({}, INITIAL_STATE)
        this.loadNotifications()
    }

    loadNotifications() {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/load-notifications`).then((res) => {
            let data = res.data.notifications
            console.log("ressssssa", res)
            let listUnsent = []
            let listSent = []
            let listAll = []
            data.map((e) => {
                e.notifications.map((item) => {
                    let obj = { ...item }
                    obj.email = e.email
                    if (!item.status) {
                        listUnsent.push(obj)
                    } else {
                        listSent.push(obj)
                    }
                    listAll.push(obj)
                })
            })
            this.setState({
                unsent_notifications: listUnsent,
                sent_notifications: listSent,
                all_notifications: listAll,
                loading: false,
                count_mail: res.data.count_mail,
            })
        })
    }

    componentDidMount() {
        // this.initAppData();
    }

    handleTabChange = (index: number): void => {
        this.setState({ selected: index })
    }

    handleReload = () => {
        this.loadNotifications()
    }

    handleSetWaitingSent = (clone) => {
        this.setState({ sent_notifications: clone })
    }

    handleSetWaitingUnSent = (clone) => {
        this.setState({ unsent_notifications: clone })
    }

    handleSetWaitingAll = (clone) => {
        this.setState({ all_notifications: clone })
    }

    renderComponent = () => {
        const {
            selected,
            unsent_notifications,
            sent_notifications,
            all_notifications,
            loading,
            count_mail,
        } = this.state

        switch (selected) {
            case 0:
                return (
                    <UnsentNotifications
                        count_mail={count_mail}
                        handleSetWaiting={this.handleSetWaitingUnSent}
                        handleReload={this.handleReload}
                        unsent_notifications={unsent_notifications}
                        loading={loading}
                    />
                )
            case 1:
                return (
                    <SentNotifications
                        count_mail={count_mail}
                        handleSetWaiting={this.handleSetWaitingSent}
                        handleReload={this.handleReload}
                        sent_notifications={sent_notifications}
                        loading={loading}
                    />
                )
            case 2:
                return (
                    <AllNotifications
                        count_mail={count_mail}
                        handleSetWaiting={this.handleSetWaitingAll}
                        handleReload={this.handleReload}
                        all_notifications={all_notifications}
                        loading={loading}
                    />
                )
            // case 3:
            //     return <NotificationsSetting />
        }
    }

    render() {
        const { selected } = this.state
        const tabs = [
            {
                id: "Unsent Notifications",
                content: "Unsent Notifications",
                accessibilityLabel: "Unsent Notifications",
                panelID: "Unsent Notifications",
            },
            {
                id: "Sent Notifications",
                content: "Sent Notifications",
                accessibilityLabel: "Sent Notifications",
                panelID: "Sent Notifications",
            },
            {
                id: "All Notifications",
                content: "All Notifications",
                accessibilityLabel: "All Notifications",
                panelID: "All Notifications",
            },
            // {
            //     id: "Settings",
            //     content: "Settings",
            //     accessibilityLabel: "Settings",
            //     panelID: "Settings",
            // },
        ]
        const disableStyle =
            this.props.plan.plan == "free" ? { opacity: 0.5, pointerEvents: "none" } : {}
        return (
            <div className="body-plan-pro">
                <div className="yta-body " style={disableStyle}>
                    <div className="yta-header2">
                        <div className="header-tabs-block">
                            <Card>
                                <Tabs
                                    tabs={tabs}
                                    selected={selected}
                                    onSelect={(index) => this.handleTabChange(index)}
                                />
                            </Card>
                        </div>
                    </div>

                    <div className="">
                        <Card>
                            <Card.Section>{this.renderComponent()}</Card.Section>
                        </Card>
                    </div>
                </div>
                {this.props.plan.plan == "free" && (
                    <span className="tooltiptext">Please upgrade to use this feature</span>
                )}
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppBodyNotifications)
